// extracted by mini-css-extract-plugin
export default {"grid":"TeamComposition_grid__Xq3F3","cell":"TeamComposition_cell__dGMJ5"};